import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ArrowExpandIcon } from '@calendly/ui/components/icons'
import { Link } from '@calendly/ui/components/link'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { LOADING_STATE } from 'actions/scheduled_events/invitee_no_show'
import { isAvailableFeatureSelector } from 'features/billing'

import { FullStoryMask } from '../../../shared/fullstory_privacy'

const HelpCenterLink = ({ children }) => (
  <Link href="https://help.calendly.com/hc/en-us/articles/4402509436823" target="_blank" rel="noopener noreferrer">
    {children}
    <ArrowExpandIcon inline />
  </Link>
)

const NoShow = ({
  inviteeName,
  onClose,
  onConfirm,
  settingNoShowStatusState
}) => {
  const followUpsAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'event_follow_up_email' }))

  return (
    <Popup
      title={<FullStoryMask>{I18n.t('publisher.scheduled_events.no_show.title', { invitee_name: inviteeName })}</FullStoryMask>}
      onClose={onClose}
    >
      <Body>
        <div>
          {I18n.t('publisher.scheduled_events.no_show.body_no_show_workflow')}
          {!followUpsAvailable && ` ${I18n.t('publisher.scheduled_events.no_show.upgrade_note')}`}
        </div>
        <div>
          {HtmlParser(I18n.t('publisher.scheduled_events.no_show.learn_more'), { HelpCenterLink })}
        </div>
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
          aria-label={I18n.t('publisher.scheduled_events.no_show.cancel')}
        >
          {I18n.t('publisher.scheduled_events.no_show.cancel')}
        </Button>
        <Button
          loading={settingNoShowStatusState === LOADING_STATE}
          onClick={onConfirm}
          aria-label={I18n.t('publisher.scheduled_events.no_show.confirm')}
        >
          {I18n.t('publisher.scheduled_events.no_show.confirm')}
        </Button>
      </Footer>
    </Popup>
  )
}

NoShow.propTypes = {
  inviteeName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  settingNoShowStatusState: PropTypes.string
}

export default NoShow
